module.exports = __webpack_public_path__ + "1cdeb219a65a39d4d39dfdad5e472f1c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logos/logo-blue-new.png
 ** module id = 316
 ** module chunks = 1
 **/